module.exports = __webpack_public_path__ + "img/blue_blueeyesdesc.5e6e123.png";